<template>
  <video-modal v-model="showVideoModal" />
  <div
    class="hero-container container container-l margin-xl-bottom flex-column-reverse flex-between flex-center flex-middle l:flex-top l:flex-between l:flex-row">
    <div class="hero-content flex-column">
      <div class="hero-title-container">
        <h1
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="block margin-m-bottom animate--delay-200 hero-content-title hide">
          <span class="c-lead">JustOpp </span>bridging the gap between
          <span class="hero-title-last-line">Manufacturers & SMB's</span>
        </h1>
      </div>
      <p
        v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
        class="hero-description text-l animate--delay-300 margin-2xl-bottom hide">
        JustOpp is an online B2B marketplace that provides a unique solution for both
        manufacturers and buyers, providing A tier inventory of quality brands at special
        pricing indexes with added values directly from the producer.
      </p>
      <div class="actions">
        <div
          v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
          class="hero-buttons animate--delay-600 gap-l flex-center flex-middle l:flex-row l:flex-start hide">
          <saffron-link
            :to="
              userVendor
                ? {
                    name: 'company-vendorId-dashboard',
                    params: { vendorId: userVendor.id },
                  }
                : { name: isLoggedIn ? 'user-dashboard' : 'user-register' }
            "
            class="plain-link hero-buttons-inner">
            <form-button theme="lead" size="large"
              >{{ t(isLoggedIn ? "justopp.hero.toDashboard" : "justopp.hero.buyers") }}
            </form-button>
          </saffron-link>
          <saffron-link 
            v-if="!isLoggedIn"
            :to="{ name: 'vendor-register' }"
            class="plain-link hero-buttons-inner">
            <form-button
              v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
              class="animate--delay-700 gap-l flex-center flex-middle l:flex-row l:flex-start hide"
              theme="lead-inverse"
              size="large"
              >{{ t("justopp.hero.sellers") }}
            </form-button>
          </saffron-link>
        </div>
        <div class="text-buttons flex gap-l margin-l-top">
          <a
            v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
            class="hero-text-button animate--delay-800 hide"
            @click="showVideoModal = true"
            ><div id="video-icon">
              <icon class="action-icon" icon="video" />
            </div>
            <span>{{ t("justopp.hero.videoCta") }}</span>
          </a>
          <a
            v-intersect="{ animate: 'fadeIn', removeClass: 'hide' }"
            class="hero-text-button animate--delay-900 hide"
            @click="scrollToElement('#hot-deals-section')"
            ><icon size="5" class="action-icon" icon="cart2" />
            <span>{{ t("justopp.hero.deals") }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="hero-image">
      <img :src="getDynamicAssetUrl('images/dev/bgimage.png')" />
    </div>
  </div>
  <div class="spacer">
    <icon
      class="cursor-pointer"
      icon="arrow-orange"
      @click="scrollToElement('#about-section')" />
    <div class="curve"></div>
  </div>
</template>

<script>
import scrollToElementMixin from "@/client/applications/justopp/extensions/mixins/scrollToElement.js";
import VideoModal from "@/client/applications/justopp/components/home/VideoModal.vue";

export default {
  name: "Hero",
  components: { VideoModal },
  mixins: [scrollToElementMixin],
  data() {
    return { showVideoModal: false };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    userVendor() {
      if (!this.userProfile) {
        return false;
      }

      if (!this.userProfile.Vendor) {
        return false;
      }

      return this.userProfile.Vendor;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.hero-content-title {
  font-size: 36px;
  font-weight: 600;
  max-width: 600px;

  @media (max-width: 1024px) {
    margin-bottom: var(--margin-s);
    font-size: var(--font-2xl);
    width: 250px;
    text-align: initial;

    .hero-title-last-line {
      width: 290px;
      display: inline-block;
    }
  }
}

.hero-image {
  height: 435px;

  @media (max-width: 1024px) {
    height: 187px;
  }

  img {
    height: 100%;
  }
}

.hero-container {
  margin-inline-start: auto;
  margin-inline-end: auto;
  padding-top: calc(var(--margin-max) * 1.5);
  max-width: 1400px;

  @media (max-width: 1750px) {
    max-width: 1250px;
  }

  @media (max-width: 1650px) {
    max-width: 1100px;
  }

  @media (max-width: 1300px) {
    max-width: 1100px;
  }

  @media (max-width: 1100px) {
    max-width: 750px;
  }

  @media (max-width: 1024px) {
    max-width: 450px;
    padding-top: var(--margin-xl);
  }

  @media (max-width: 767px) {
    max-width: 70%;
  }

  @media (max-width: 500px) {
    max-width: 100%;
  }
}

.hero-content {
  @media (max-width: 1600px) {
    max-width: 700px;
  }

  @media (max-width: 1200px) {
    max-width: 550px;
  }

  @media (max-width: 1024px) {
    max-width: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.hero-title-container {
  @media (max-width: 1024px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
}

.hero-buttons {
  button {
    width: 250px;
  }

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    .hero-buttons-inner {
      flex: 50%;
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
}

.hero-text-button {
  color: var(--c-text);
  display: flex;
  align-items: center;
  gap: var(--margin-s);
  font-size: var(--font-l);
  cursor: pointer;

  span {
    text-decoration: underline;
    transition: color 0.4s ease 0s;
  }

  &:hover {
    span {
      color: var(--c-lead);
    }
  }

  .action-icon {
    width: 35px !important;
    height: 35px !important;
    flex: 1 !important;
  }
}

#video-icon {
  .action-icon {
    height: 30px !important;
    width: 37px !important;
  }

  display: flex;
  align-items: center;
  width: 45px;
  height: 45px;
  background-color: var(--c-lead);
  border-radius: 50%;
  padding: var(--margin-s);
}

.text-buttons {
  @media (max-width: 1024px) {
    justify-content: space-between;
  }
}

.actions {
  width: 100%;
}

.hero-description {
  max-width: 600px;

  @media (max-width: 1024px) {
    order: 1;
    margin-top: var(--margin-xl);
    text-align: start;
    animation-delay: 1000ms;
    margin-bottom: 0 !important;
  }
}

.spacer {
  z-index: 10;
  width: 100%;
  height: 80px;
  text-align: center;
  color: var(--c-lead);
  margin-top: calc(var(--margin-max) * 2);
  background-color: var(--c-lead);
  position: relative;

  i {
    z-index: 10;
    width: 41px !important;
    height: 25px !important;
    flex: 1 !important;
  }

  .curve {
    z-index: -1;
    background-color: var(--c-bg);
    height: 100%;
    clip-path: ellipse(115% 135px at 100% -50%);
    position: absolute;
    top: 0;
    width: 100%;
  }

  @media (max-width: 1024px) {
    height: 50px;
    margin-top: var(--margin-2xl);

    .curve {
      height: 30px;
      clip-path: ellipse(115% 48px at 100% -55%);
    }

    i {
      position: absolute;
      top: -30px;
      left: 50%;
      transform: translateX(-50%);
      width: 26px !important;
      height: 16px !important;
      flex: 1 !important;
    }
  }
}

.hide {
  opacity: 0;
}
</style>
